module.exports = __webpack_public_path__ + "img/hc_pro_three_9.0d8bd91f.jpg";